import { HttpHeaders, HttpParams, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  constructor(private _http: HttpClient) {}

  getData(url:string): Observable<any> {
    return this._http.get(url);
  }
}
